import {Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';

import {ToolService} from './tool.service';

@Component({
  selector: 'app-tool',
  templateUrl: './tool.component.html',
  styleUrls: ['./tool.component.scss']
})
export class ToolComponent implements OnInit {
  previewShowen: boolean;
  subscriber: Subscription;

  constructor(
    public toolService: ToolService
  ) {}

  ngOnInit(): void {
    this.subscriber = this.toolService.previewShowen.subscribe( (isPreview: boolean) => this.previewShowen = isPreview);
  }
}
